/** The `environment.urls` web-app keys the switcher reads; each comes from Azure App Configuration (`Urls:<Key>Web@<env>`). */
export interface UpsAppSwitcherUrls {
  myWeb?: string;
  resourceAllocationWeb?: string;
  warehouseWeb?: string;
  spartaWeb?: string;
  hseToolboxWeb?: string;
  appStoreWeb?: string;
}

/** One app switcher entry; structurally an AppSwitcherItem of any UPS header. */
export interface UpsAppSwitcherEntry {
  name: string;
  icon: string;
  url: string;
}

/**
 * The UPS app switcher entries, built from the environment's web-app URLs like the shared navbar's list
 * (NIFTY is the warehouse app). Never hard-code app hosts here: the short names (my., sparta., safety. ...)
 * do not resolve. An entry whose URL is not an absolute https URL (an unset key in dev, a relative path) is
 * left out, so the switcher never renders a dead link.
 */
export function upsAppSwitcherItems(
  urls: UpsAppSwitcherUrls | null | undefined
): UpsAppSwitcherEntry[] {
  const u = urls ?? {};
  const resourceAllocation = u.resourceAllocationWeb
    ? `${u.resourceAllocationWeb.replace(/\/+$/, '')}/home`
    : undefined;
  const entries: Array<{ name: string; icon: string; url?: string }> = [
    { name: 'My UPS', icon: 'assets/my-ups.svg', url: u.myWeb },
    {
      name: 'Resource Allocation',
      icon: 'assets/employee-portal.svg',
      url: resourceAllocation,
    },
    { name: 'NIFTY', icon: 'assets/nifty.svg', url: u.warehouseWeb },
    { name: 'SPARTA', icon: 'assets/sparta.svg', url: u.spartaWeb },
    { name: 'HSE Toolbox', icon: 'assets/safety.svg', url: u.hseToolboxWeb },
    {
      name: 'UPS Appstore',
      icon: 'assets/sign-up-form-img.svg',
      url: u.appStoreWeb,
    },
  ];
  return entries.filter((e): e is UpsAppSwitcherEntry =>
    isAbsoluteHttps(e.url)
  );
}

function isAbsoluteHttps(url: string | undefined): boolean {
  if (!url) {
    return false;
  }
  try {
    const parsed = new URL(url);
    return parsed.protocol === 'https:' && parsed.hostname.includes('.');
  } catch {
    return false;
  }
}
